/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { secureControllerHasSecondaryPassword } from '../fn/secure/secure-controller-has-secondary-password';
import { SecureControllerHasSecondaryPassword$Params } from '../fn/secure/secure-controller-has-secondary-password';
import { secureControllerResetSecondaryPassword } from '../fn/secure/secure-controller-reset-secondary-password';
import { SecureControllerResetSecondaryPassword$Params } from '../fn/secure/secure-controller-reset-secondary-password';
import { secureControllerSetSecondaryPassword } from '../fn/secure/secure-controller-set-secondary-password';
import { SecureControllerSetSecondaryPassword$Params } from '../fn/secure/secure-controller-set-secondary-password';
import { secureControllerVerifySecondaryPassword } from '../fn/secure/secure-controller-verify-secondary-password';
import { SecureControllerVerifySecondaryPassword$Params } from '../fn/secure/secure-controller-verify-secondary-password';

@Injectable({ providedIn: 'root' })
export class SecureService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `secureControllerSetSecondaryPassword()` */
  static readonly SecureControllerSetSecondaryPasswordPath = '/api/secure/center/{centerId}/secondary-password';

  /**
   * 2차 비밀번호 설정 (대표자 전용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secureControllerSetSecondaryPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secureControllerSetSecondaryPassword$Response(params: SecureControllerSetSecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return secureControllerSetSecondaryPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 2차 비밀번호 설정 (대표자 전용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `secureControllerSetSecondaryPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secureControllerSetSecondaryPassword(params: SecureControllerSetSecondaryPassword$Params, context?: HttpContext): Observable<void> {
    return this.secureControllerSetSecondaryPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `secureControllerVerifySecondaryPassword()` */
  static readonly SecureControllerVerifySecondaryPasswordPath = '/api/secure/center/{centerId}/secondary-password/verify';

  /**
   * 2차 비밀번호 검증 (마스킹 해제용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secureControllerVerifySecondaryPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secureControllerVerifySecondaryPassword$Response(params: SecureControllerVerifySecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return secureControllerVerifySecondaryPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 2차 비밀번호 검증 (마스킹 해제용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `secureControllerVerifySecondaryPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  secureControllerVerifySecondaryPassword(params: SecureControllerVerifySecondaryPassword$Params, context?: HttpContext): Observable<boolean> {
    return this.secureControllerVerifySecondaryPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `secureControllerHasSecondaryPassword()` */
  static readonly SecureControllerHasSecondaryPasswordPath = '/api/secure/center/{centerId}/secondary-password/status';

  /**
   * 2차 비밀번호 설정 여부 확인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secureControllerHasSecondaryPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  secureControllerHasSecondaryPassword$Response(params: SecureControllerHasSecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return secureControllerHasSecondaryPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 2차 비밀번호 설정 여부 확인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `secureControllerHasSecondaryPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secureControllerHasSecondaryPassword(params: SecureControllerHasSecondaryPassword$Params, context?: HttpContext): Observable<void> {
    return this.secureControllerHasSecondaryPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `secureControllerResetSecondaryPassword()` */
  static readonly SecureControllerResetSecondaryPasswordPath = '/api/secure/center/{centerId}/secondary-password/reset';

  /**
   * 2차 비밀번호 초기화 (대표자 전용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `secureControllerResetSecondaryPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  secureControllerResetSecondaryPassword$Response(params: SecureControllerResetSecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return secureControllerResetSecondaryPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 2차 비밀번호 초기화 (대표자 전용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `secureControllerResetSecondaryPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  secureControllerResetSecondaryPassword(params: SecureControllerResetSecondaryPassword$Params, context?: HttpContext): Observable<void> {
    return this.secureControllerResetSecondaryPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
